var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-board"},[(_vm.pics)?_vm._l((_vm.pics),function(item,index){return _c('div',{key:index,staticClass:"head-board-content"},[_c('img',{attrs:{"src":item.banner.thumb_url,"alt":""},on:{"click":function($event){return _vm.go(item.banner.url)}}})])}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }